module.exports = __webpack_public_path__ + "img/vendor-new-icon.9fca3efc.svg";